export default __webpack_public_path__ + "static/media/file_00003 (2).a87e1c77.pdf";